<template>
  <div class="container-activity">
    <MpNavbar active="activity" />
    <MpTitle title="我的杯测活动" intro="仅展示我所创建的咖啡杯测活动，可点击查看详情查看打分情况" />
    <div class="content-table" v-show="tableData">
      <!-- height="300" :loading="loading" -->
      <vxe-toolbar>
        <template #buttons>
          <vxe-button @click="reflash">刷新</vxe-button>
          <!-- <vxe-button @click="exportDataEvent">导出.xlsx</vxe-button> -->
        </template>
      </vxe-toolbar>
      <vxe-table round border highlight-hover-row resizable :data="tableData">
        <vxe-table-column type="seq" width="60"></vxe-table-column>
        <!-- <vxe-table-column field="id" title="ID" width="60"></vxe-table-column> -->
        <vxe-table-column field="createTime" :formatter="formatTime" title="创建时间" width="150"></vxe-table-column>
        <vxe-table-column field="category" title="分类标签" :formatter="formatCategory" width="100"></vxe-table-column>
        <vxe-table-column field="title" title="活动名称"></vxe-table-column>
        <vxe-table-column field="cupsCount" title="咖啡豆数量" :formatter="formatCups" width="120"></vxe-table-column>
        <vxe-table-column field="tableId" title="杯测表" :formatter="formatTable" width="250"></vxe-table-column>
        <vxe-table-column field="status" title="状态" :formatter="formatStste" width="120">
          <template #default="{ row, rowIndex }">
            <vxe-switch v-model="row.status" :open-value="1" :close-value="2" disabled></vxe-switch>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作" width="200">
          <template #default="{ row, rowIndex }">
            <van-button color="#489D80" size="small" round @click="goDetail(row.uuid)">杯测结果详表</van-button>
            <van-button style="margin-left: 6px;" color="#13ACA7" size="small" round @click="goGather(row.uuid)">风味汇总表</van-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager background size="small" :loading="loading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :page-sizes="[10, 20, 100]" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange">
      </vxe-pager>
    </div>
  </div>
</template>

<script>
  import MpNavbar from '../../components/mp/navbar'
  import MpTitle from '../../components/mp/title'
  import { apiActivity } from '../../request/api'
  import Vue from 'vue';
  import { Button } from 'vant';

  Vue.use(Button);

  export default {
    components: {
      MpNavbar,
      MpTitle
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        loading: false,
        tableData: null,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        },
        constantActivityCategory: null,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.constantActivityCategory = JSON.parse(localStorage.getItem("constantActivityCategory"))
        this.getActivity()
      },
      reflash() {
        this.tablePage = {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        }
        this.tableData = null
        this.getActivity()

      },
      getActivity() {
        let self = this
        self.loading = true
        apiActivity({
          page: self.tablePage.currentPage,
          size: self.tablePage.pageSize,
        }).then(res => {
          console.log(res.data)
          self.tableData = res.data.items
          self.tablePage.totalResult = res.data.count
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      handlePageChange({ currentPage, pageSize }) {
        console.log(currentPage)
        console.log(pageSize)
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.getActivity()
      },
      formatTime({ cellValue, row, column }) {
        let time = new Date(cellValue)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) { month = '0' + month }
        if (date < 10) { date = '0' + date }
        if (hours < 10) { hours = '0' + hours }
        if (minute < 10) { minute = '0' + minute }
        if (second < 10) { second = '0' + second }
        return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
      },
      formatStste({ cellValue, row, column }) {
        if (cellValue == 1) {
          return "🟢 进行中"
        }
        else if (cellValue == 2) {
          return "🔴 已结束"
        } else {
          return "未知状态"
        }
      },
      formatCups({ cellValue, row, column }) {
        return cellValue + "个"
      },
      formatTable({ cellValue, row, column }) {
        if (cellValue == 1) {
          return "简易杯测表"
        } else if(cellValue == 2){
          return "SCAA杯测表"
        } else if(cellValue == 3){
          return "COE杯测表"
        } else if(cellValue == 4){
          return "世界咖啡冲煮大赛（指定冲煮）感官评分表"
        } else if(cellValue == 5){
          return "世界咖啡烘焙大赛评分表"
        } else if(cellValue == 6){
          return "咖啡饮品感官评分简表"
        } else if(cellValue == 7){
          return "Roster’s Commu.烘焙赛评分表"
        }
        else {
          return "其它"
        }
      },
      formatCategory({ cellValue, row, column }) {
        let result
        for (let index = 0; index < this.constantActivityCategory.length; index++) {
          if (this.constantActivityCategory[index].key == cellValue) {
            result = this.constantActivityCategory[index].value
          }
        }
        return result
      },
      goDetail(uuid) {
        this.go("mp/activity/detail/"+uuid)
      },
      goGather(uuid) {
        this.go("mp/activity/gather/"+uuid)
      },
      go(where) {
        this.$router.push('/' + where)
      },
    }
  }
</script>

<style scoped>
  .container-activity {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    padding-left: 110px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }
</style>